/**
 * Staged rollout gate for the redesigned widget UI.
 *
 * The redesign is a visible change for every existing bot, so it ships to the
 * workspaces listed here first. Everyone else keeps the previous look until
 * this list is widened.
 *
 * `workspace_id` comes from the widget-config response — geta-core sets
 * `chatbot.workspace_id` to the request's schema name.
 *
 * To widen the rollout, add workspace ids here and rebuild the widget. To make
 * it available to everyone, delete this module and the `isNewUiWorkspace()`
 * calls that read it — the theme's own `industry_style.enabled` flag then
 * takes over again on its own.
 */
export const NEW_UI_WORKSPACES: string[] = [
  "ashish_in_4zVzywwG",
  "getamsg_com_4QVsqGxG",
  "sadashiv_sambarkar+sandboxreal_tjpcgwAP_Q1Ez",
  "prasadc_com_BKPdtgjx",
  "sithyd_siu_edu_in_r5EkpnGA",
];

export const isNewUiWorkspace = (workspaceId?: string | null): boolean =>
  !!workspaceId && NEW_UI_WORKSPACES.includes(workspaceId);
